const filterFreeTours = (activities = []) =>
	activities.filter(
		(a) => !a.isFreeTour && a.subcategory?.id !== 109
	);

export default filterFreeTours;
